import React from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";

const AdminTabs = () => {
  const location = useLocation();
  const { slug } = useParams();

  const base = `/admin/${slug}`;
  const tabs = [
    { to: base, label: "Resumen" },
    { to: `${base}/perfil`, label: "Perfil" },
    { to: `${base}/settings`, label: "Configuracion" },
    { to: `${base}/qrview`, label: "QRs" },
    { to: `${base}/productos`, label: "Productos" },
    { to: `${base}/review`, label: "Reviews" },
  ];

  return (
    <Nav variant="pills" className="mb-3 flex-nowrap overflow-auto admin-tabs">
      {tabs.map((t) => (
        <Nav.Item key={t.to}>
          <Nav.Link as={Link} to={t.to} active={location.pathname === t.to} className="px-3">
            {t.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default AdminTabs;
